import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { WatchlistManagerWidget } from '~/widgets/watchlist-manager-widget/WatchlistManagerWidget';

import * as S from './WatchlistManagerModal.styles';

export const WatchlistManagerModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onClose = () => {
    searchParams.delete('widget');
    setSearchParams(searchParams);
  };

  return (
    <S.StyledModal data-testid="asset-overview-modal" isOpen onClose={onClose}>
      <WatchlistManagerWidget onListCreated={onClose} onCancel={onClose} />
    </S.StyledModal>
  );
};
